import axios from 'axios';

/**
 *
 */ class ChatService {
  /**
   *
   * @param {*} sessionId
   * @returns
   */
  static async createMessageThread(sessionId) {
    try {
      const res = await axios.post(
        `/thread`,
        {
          uuid: sessionId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   *
   * @param {*} sessionId
   * @returns
   */
  static async fetchMessageThread(sessionUuid) {
    try {
      const res = await axios.get(route('chat.getThread'), { params: { uuid: sessionUuid } });
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   *
   * @param {*} sessionId
   * @param {*} messagePayload
   * @returns
   */
  static async addNewMessage(sessionUuid, messagePayload) {
    const messageFormData = new FormData();
    messageFormData.append('uuid', sessionUuid);
    messageFormData.append('message', messagePayload.content);
    messageFormData.append('type', messagePayload.type);
    messageFormData.append('attachment', JSON.stringify(messagePayload.attachment));
    messageFormData.append('send_to', messagePayload.sendTo);
    messageFormData.append('phase', JSON.stringify(messagePayload.phase));

    try {
      const res = await axios.post(route('chat.sendMessageToThread'), messageFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   * This is used to update a message that has been viewed by Clinician on the smart glass
   * @param {*} messageId
   * @param {*} sessionId
   * @returns
   */
  static async handleMessage(messageId, sessionId) {
    try {
      const res = await axios.post(
        `/thread/messages/handle`,
        {
          id: messageId,
          uuid: sessionId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   * Fetch unhandled messages
   * @param {*} sessionId
   * @returns
   */
  static async fetchUnhandledMessages(sessionId) {
    try {
      const res = await axios.get(`/thread/messages/unhandled/${sessionId}`);
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }

  /**
   * Upload attachment to be used in the chat
   * @param {*} formData
   * @returns
   */
  static async uploadAttachment(formData) {
    try {
      const res = await axios.post(route('chat.attachment'), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res.data;
    } catch (error) {
      throw error.response;
    }
  }
}

export default ChatService;
